import ContentLoader from 'react-content-loader';

interface TransactionsLoaderProps {
	className?: string;
}

export const TransactionsLoader = (props: TransactionsLoaderProps) => (
	<ContentLoader
		width="100%"
		height={280}
		backgroundColor={'#ffffff'}
		foregroundColor={'#f2f6f6'}
		backgroundOpacity={0.4}
		foregroundOpacity={0.5}
		className={props.className}
	>
		<rect x="5%" y="20" rx="0" ry="0" width="90%" height="50" />
		<rect x="5%" y="85" rx="0" ry="0" width="90%" height="50" />
		<rect x="5%" y="150" rx="0" ry="0" width="90%" height="50" />
		<rect x="5%" y="215" rx="0" ry="0" width="90%" height="50" />
		<rect x="5%" y="280" rx="0" ry="0" width="90%" height="50" />
	</ContentLoader>
);
